export default __webpack_public_path__ + "static/media/02.6a0bb2f0.jpg";